import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
export class Payoneer {
  constructor() {
    _defineProperty(this, "PayoneerCountryID", {
      fieldName: 'country_id',
      fieldTitle: 'Country Id',
      fieldType: 'id',
      content: null
    });
    _defineProperty(this, "PayoneerUserID", {
      fieldName: 'user_id',
      fieldTitle: 'User Id',
      fieldType: 'id',
      content: null
    });
    _defineProperty(this, "PayoneerFullName", {
      fieldName: 'payoneer_full_name',
      fieldTitle: 'global_text.payment_fields.payoneer.name',
      fieldType: 'content',
      content: null
    });
    _defineProperty(this, "PayoneerEmail", {
      fieldName: 'payoneer_email',
      fieldTitle: 'global_text.payment_fields.payoneer.email',
      fieldType: 'content',
      content: null
    });
  }
}
export default Payoneer;